import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { chatbotendpoints } from "../apis";

const { CHATBOT_API } = chatbotendpoints;

//  Call chatbot API with required parameters
export async function chatbot({ conversation_id, query }) {

  try {
    const response = await apiConnector("POST", CHATBOT_API, {
      conversation_id,
      query,
    });
     //console.log("res",response.data.data)

    if (!response.data.success) throw new Error(response.data.message);

   // console.log("Chatbot response:", response.data.data.response);
    return response.data.data.response; 
  } catch (error) {
    console.error("Failed to call chatbot API", error);
    toast.error(error.message || "Failed to call chatbot API");
    return null;
  }
}
